export default [
  //GAZzete
  {
    path: "1Qz1577fad904bb156843f8b9a2raK",
    name: "bece26.gazettes",
    component: () => import("@/views/bece/tws/gazette/list.vue"),
    meta: {
      title: "Bece 2026 Gazette(s)",
      authRequired: true,
      acc: ["y44791"],
    },
  },
  {
    path: "y0O816002ec36167d93169590fe8xgRoEb",
    name: "bece26.pendinggazettereq",
    component: () => import("@/views/bece/tws/gazette/pendingrequests.vue"),
    meta: {
      title: "Bece 2026 Pending Gazette Request(s)",
      authRequired: true,
      acc: ["y81365"],
    },
  },
  {
    path: "Og51637974726a4e4afcce63267OPct",
    name: "bece26.uploadgazette",
    component: () => import("@/views/bece/tws/gazette/upload.vue"),
    meta: {
      title: "Upload Bece 2026 Gazette",
      authRequired: true,
      acc: ["y57548"],
    },
  },
  {
    path: "NqR16dc124ccdb52484aa175363WUXQ",
    name: "bece26.uploadedgazettes",
    component: () => import("@/views/bece/tws/gazette/uploaded-gazette.vue"),
    meta: {
      title: "Uploaded Bece 2026 Gazettes",
      authRequired: true,
      acc: ["y82953"],
    },
  },
  {
    path: "168fef15c5687f07f28cf7d8/:er?",
    name: "bece26.gazette",
    component: () => import("@/views/bece/tws/gazette/vgazette.vue"),
    meta: {
      title: "Print Bece Gazette",
      authRequired: true,
      acc: ["y34980"],
    },
  },
];
